/**
 * Message input height constants
 *
 * Fixed-height approach (Phase 4):
 * - 6 lines at 16px font = 24px line height × 6 = 144px
 * - Plus 24px padding (12px top + 12px bottom) = 168px
 * - Prevents keyboard cutting on mobile
 *
 * Source of Truth: This constant is used by:
 * - useAutoGrowInput.ts (calculates fixed input height)
 * - useDockingState.ts (keyboard docking behavior)
 */
export const MESSAGE_INPUT_HEIGHT = 168;
export const MESSAGE_INPUT_LINES = 6;
export const MESSAGE_INPUT_FONT_SIZE = 16;
export const MESSAGE_INPUT_LINE_HEIGHT = 24;
export const MESSAGE_INPUT_PADDING_VERTICAL = 24;
